import type { TMessages } from '@/types/TMessages'

export const messages = {
  header: 'Продайте урожай на своих условиях',
  lead: 'Продавцы урожая свяжутся с вами, если им подойдут ваши условия',
  buttonText: 'Создать заявку',
} satisfies TMessages
